import React, { useState, useEffect, useRef } from "react";
import "../styles/Login.css";
import { Link } from "react-router-dom";
import { buildApiUrl, API_ENDPOINTS, APP_DISPLAY_NAME } from "../config/api";

const VerifyEmail = () => {
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const [resendEmail, setResendEmail] = useState("");
  const [resendStatus, setResendStatus] = useState(null);
  const hasVerified = useRef(false);

  useEffect(() => {
    if (hasVerified.current) return;
    hasVerified.current = true;

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      setStatus("error");
      setMessage("No se encontró un token de verificación en la URL.");
      return;
    }

    fetch(
      `${buildApiUrl(API_ENDPOINTS.verifyEmail)}?token=${encodeURIComponent(token)}`,
      { credentials: "include" }
    )
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          setStatus("success");
        } else {
          setStatus(data.code === "TOKEN_EXPIRED" ? "expired" : "error");
        }
        setMessage(data.message);
      })
      .catch(() => {
        setStatus("error");
        setMessage("Error de conexión. Intenta nuevamente.");
      });
  }, []);

  const handleResend = async (e) => {
    e.preventDefault();
    setResendStatus("sending");
    try {
      const res = await fetch(buildApiUrl(API_ENDPOINTS.resendVerification), {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: resendEmail }),
      });
      const data = await res.json();
      setResendStatus(data.success ? "sent" : "error");
    } catch {
      setResendStatus("error");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src="/LOGOCETIUCLOGIN.png" alt={APP_DISPLAY_NAME} />
        </div>

        <h2 className="login-title">Verificación de correo</h2>

        {status === "loading" && (
          <p className="login-subtitle">Verificando tu correo electrónico…</p>
        )}

        {status === "success" && (
          <>
            <p className="login-subtitle" style={{ color: "var(--accent-color)" }}>
              {message}
            </p>
            <Link
              to="/login"
              className="login-submit-btn"
              style={{ textDecoration: "none", textAlign: "center", display: "block", marginTop: "16px" }}
            >
              Iniciar sesión
            </Link>
          </>
        )}

        {(status === "error" || status === "expired") && (
          <>
            <p className="login-subtitle" style={{ color: "var(--error-color)" }}>
              {message}
            </p>

            {status === "expired" && (
              <form onSubmit={handleResend} className="login-form" style={{ marginTop: "8px" }}>
                <div className="login-field">
                  <label htmlFor="resend-email">Tu correo electrónico</label>
                  <input
                    id="resend-email"
                    type="email"
                    value={resendEmail}
                    onChange={(e) => setResendEmail(e.target.value)}
                    placeholder="tunombre@mail.com"
                    required
                  />
                </div>
                {resendStatus === "sent" && (
                  <span className="login-error" style={{ color: "var(--accent-color)" }}>
                    Si el correo existe y no está verificado, recibirás el enlace en tu bandeja.
                  </span>
                )}
                {resendStatus === "error" && (
                  <span className="login-error">Error al enviar. Intenta nuevamente.</span>
                )}
                <button
                  type="submit"
                  className="login-submit-btn"
                  disabled={resendStatus === "sending" || resendStatus === "sent"}
                >
                  {resendStatus === "sending"
                    ? "Enviando…"
                    : "Reenviar correo de verificación"}
                </button>
              </form>
            )}

            <div className="login-links-row" style={{ marginTop: "16px" }}>
              <Link to="/login" className="login-secondary-link">
                Volver al inicio de sesión
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
